import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { BoxModule } from '../../../components/box/box.module';
import { ItemModule } from '../../../components/item/item.module';
import { TranslateModule } from '../../../components/translate/translate.module';
import { DaterModule } from '../../../pipes/dater/dater.module';
import { MergedCasesListItemComponent } from './list-item/merged-cases-list-item';
import { MergedCase } from './merged-case.type';

@Component({
  selector: 'apex-case-merged-cases',
  templateUrl: './case-merged-cases.component.html',
  standalone: true,
  imports: [
    CommonModule,
    BoxModule,
    TranslateModule,
    MergedCasesListItemComponent,
    ItemModule,
    DaterModule,
    MatDividerModule,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
  ],
})
export class CaseMergedCasesComponent {
  @Input()
  mergedCases?: MergedCase[] = [];

  @Input()
  showClearSelection = false;

  @Output()
  clearSelection: EventEmitter<void> = new EventEmitter();
}
